import type { MyCompanyResponse } from '@/types';

function normalizeText(value: string) {
  return value
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .trim();
}

export function filterCompanyEntries(companies: readonly MyCompanyResponse[], searchTerm: string) {
  const trimmedSearch = searchTerm.trim();
  if (!trimmedSearch) {
    return [...companies];
  }

  const normalizedSearch = normalizeText(trimmedSearch);
  const numericSearch = trimmedSearch.replace(/\D/g, '');

  return companies.filter((entry) => {
    const normalizedName = normalizeText(entry.company.name);
    const registerNumber = entry.company.registerNumber?.replace(/\D/g, '') ?? '';

    return (
      normalizedName.includes(normalizedSearch) || (numericSearch.length > 0 && registerNumber.includes(numericSearch))
    );
  });
}
